import * as React from 'react';
import { Map, Marker, Popup, TileLayer, Polyline } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import * as L from 'leaflet';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Control from 'react-leaflet-control';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { actions } from 'react-redux-form';
import moment from 'moment';
import TruckCard from './TruckCard'
import UnitCard from './TrailerCard'
import { bindActionCreators } from 'redux';
import * as UnitStore from '../units/store/unitStore'
import * as TruckStore from '../trucks/store/truckStore'
import * as CompaniesStore from '../companies/store/companyStore';
import * as FsStore from '../account/store/FilterSettingsStore';
import { ApplicationState } from "../store";
import FilterPanel from '../components/tables/FilterPanel'
import MapFilter from './MapFilter'
import { MapFilterInfo, LocationNameModel, Reporter, FilterInfo, VisibleCompanyDataModel, CompanyIndustryType, FilterMode, LocationModel } from '../common/models/CommonModels';
import { AddNewTruckModel, TruckModel } from "../trucks/TruckModels";
import { UnitModel, AddUnitModel } from "../units/UnitModels";
import * as filtersApi from '../api/filterValuesApi';
import * as locationApi from '../api/locationsApi';
import { localizations } from '../localization/localization';
import HelpButton from '../help/HelpButton';
import { showTruckRoutes, showDepartingArrivingUnits, showDepartingTrucks, showCompanies } from './RoutesState'
import { makeCancellable, CancellablePromise } from '../utils/makeCancellable';
import nameof from '../utils/nameof';

import './Map.css';
import TruckImage from "./images/ic_rekka_a.svg"; // Was this meant to be changed?
import TruckImageRed from "./images/ic_rekka_b.svg"; // Was this meant to be changed?
import BulkTruckImage from "./images/4_lavallinen_kuorma_auto_a.svg"; // Lavallinen kuorma-auto, irto/bulk
import BulkTruckImageRed from "./images/4_lavallinen_kuorma_auto_b.svg"; // Lavallinen kuorma-auto, irto/bulk
import PieceTruckImage from "./images/ic_kappaletavarakuljetus_a.svg"; // kappaletavarakuljetus, piece
import PieceTruckImageRed from "./images/ic_kappaletavarakuljetus_b.svg"; // kappaletavarakuljetus, piece
import TrailerImage from "./images/ic_peravaunu_a.svg";
import TrailerImageRed from "./images/ic_peravaunu_b.svg";
import CompanyImage from "./images/company.png";
import DeliveryCompanyImage from "./images/ic_kuljetus_huolinta_yritykset.svg"; // Delivery company image
import TransportationImage from "./images/transportation.png";
import RetailImage from "./images/retail.png";
import RedMarker from "./images/red-marker.png";
import BlueMarker from "./images/blue-marker.png";
import TruckTooltip from './TruckTooltip';
import UnitTooltip from './UnitTooltip';
import CompanyTooltip from './CompanyTooltip';
import CompanyCard from './CompanyCard';
import BulkgoodsImage from "./images/3_ic_irtotavara_a.svg";
import BulkgoodsImageRed from "./images/3_ic_irtotavara_b.svg";
import PiecegoodsImage from "./images/ic_kappaletavara_a.svg";
import PiecegoodsImageRed from "./images/ic_kappaletavara_b.svg";
import SeaContainerImage from "./images/ic_merikontti_a.svg";
import SeaContainerImageRed from "./images/ic_merikontti_b.svg";
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import UnitEmailDialog from '../units/forms/UnitEmailDialog';
import TruckEmailDialog from '../trucks/forms/TruckEmailDialog';
import AddNewUnitForm from '../units/forms/AddNewUnitForm';
import AddFreeTruckForm from '../trucks/forms/AddFreeTruckForm';

const styles = (theme: Theme) => ({
  paper: {
      margin: "2px",
      backgroundColor: "transparent"
  }
});

const myCustomRedColour = '#ED1C29'
const myCustomBlueColour = '#013759';
const myCustomSelectionColor = "#00FF00";

const cardWidth = 550;

const PieceTruckIconRed = L.icon({
  iconUrl: PieceTruckImageRed,
  className: "icon icon-red",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const PieceTruckIconBlue = L.icon({
  iconUrl: PieceTruckImage,
  className: "icon icon-blue",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const BulkTruckIconRed = L.icon({
  iconUrl: BulkTruckImageRed,
  className: "icon icon-red",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const BulkTruckIconBlue = L.icon({
  iconUrl: BulkTruckImage,
  className: "icon icon-blue",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});

const SeaContainerIconRed = L.icon({
  iconUrl: SeaContainerImageRed,
  className: "icon icon-red",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
const SeaContainerIconBlue = L.icon({
  iconUrl: SeaContainerImage,
  className: "icon icon-blue",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
const PiecegoodsIconRed = L.icon({
  iconUrl: PiecegoodsImageRed,
  className: "icon icon-red",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const PiecegoodsIconBlue = L.icon({
  iconUrl: PiecegoodsImage,
  className: "icon icon-blue",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const BulkgoodsIconRed = L.icon({
  iconUrl: BulkgoodsImageRed,
  className: "icon icon-red",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const BulkgoodsIconBlue = L.icon({
  iconUrl: BulkgoodsImage,
  className: "icon icon-blue",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const TruckIconRed = L.icon({
  iconUrl: TruckImageRed,
  className: "icon icon-red",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const TruckIconBlue = L.icon({
  iconUrl: TruckImage,
  className: "icon icon-blue",
  iconSize: [32, 42],
  iconAnchor: [16, 28],
});
const TrailerIconRed = L.icon({
  iconUrl: TrailerImageRed,
  className: "icon icon-red",
  iconSize: [26, 26],
  iconAnchor: [13, 13],
});
const TrailerIconBlue = L.icon({
  iconUrl: TrailerImage,
  className: "icon icon-blue",
  iconSize: [26, 26],
  iconAnchor: [13, 13],
});
const CompanyIcon = L.icon({
  iconUrl: CompanyImage,
  className: "icon",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
const DeliveryCompanyIcon = L.icon({
  iconUrl: DeliveryCompanyImage,
  className: "icon",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
const TransportationIcon = L.icon({
  iconUrl: TransportationImage,
  className: "icon",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});
const RetailIcon = L.icon({
  iconUrl: RetailImage,
  className: "icon",
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

interface Geo {
  lat: number;
  lng: number;
}

interface MapViewState {
  centerPosition: Geo;
  zoom: number,
  routesChecked: MapFilterInfo,
  selectedTargetId: string | null,
  reporters: Reporter[]
  height: number;
  selectedMarker: Geo,
  truckSelected: boolean | null,
  routeLocation: string | null,
  unitRouteLocation: string | null,
  truckRoutes: boolean | null,
  selectedTruck: TruckModel | null
  selectedUnit: UnitModel | null,
  companySelected: boolean,
  selectedCompany: VisibleCompanyDataModel | null,
  isCreateReportDialogOpen: boolean,
  filters: FilterInfo,
  locations: LocationModel[],
  selectedCoordinates: Geo,
}

interface RouterProps {
  router: any
}

const createClusterCustomIconGrey = (cluster: any) => {
  if (cluster._cLatLng.lat === 59.835349 && cluster._cLatLng.lng === 22.96487) {
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: 'turquoise-marker',
      iconSize: L.point(42, 42, true),
      iconAnchor: [21, 21],
    });
  }
  else {
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: 'grey-marker',
      iconSize: L.point(42, 42, true),
      iconAnchor: [21, 21],
    });
  }
}

const mapMaxBounds: L.LatLngBoundsExpression = [
  [74, 18],
  [58, 34]
];

enum RouteType {
  Trucks = "truck",
  Units = "unit"
}

type MapViewProps = {
  filterSettingsActions: typeof FsStore.actionsCreators,
  unitActions: typeof UnitStore.actionCreators,
  truckActions: typeof TruckStore.actionCreators,
  companyActions: typeof CompaniesStore.actionCreators,
  goToActions: typeof goActions,
  setFormValue: (model: string, value: any) => void,
} & {
  filterSettings: FsStore.FilterSettingsState,
  units: UnitStore.FreeUnitState,
  trucks: TruckStore.TrucksState,
  companies: CompaniesStore.CompanyState
}

class MapView extends React.Component<WithStyles & MapViewProps, MapViewState, RouterProps>  {
  private mapComponent: any = React.createRef<Map>();
  private selectedTarget: string | null = null;
  private reportersPromise: CancellablePromise<Reporter[] | never[]> | null = null;
  private locationsPromise: CancellablePromise<LocationModel[]> | null = null;
  private hoverRouteLayer: L.LayerGroup | null = null;

  constructor(props: WithStyles & MapViewProps, context: any) {
    super(props, context);

    this.state = {
      centerPosition: {
        lat: 61.416656,
        lng: 24.577348
      },
      zoom: 7,
      routesChecked: {
        truckRoutes: showTruckRoutes,
        departingArrivingUnits: showDepartingArrivingUnits,
        departingTrucks: showDepartingTrucks,
        companies: showCompanies
      },
      selectedTargetId: null,
      reporters: [],
      height: 800,
      selectedMarker: {
        lat: 0,
        lng: 0,
      },
      truckSelected: null,
      routeLocation: null,
      unitRouteLocation: null,
      truckRoutes: null,
      selectedTruck: null,
      selectedUnit: null,
      companySelected: false,
      selectedCompany: null,
      isCreateReportDialogOpen: false,
      filters: {
        filterMode: FilterMode.All,
        fromCities: [],
        fromDate: moment().startOf("day"),
        properties: [],
        reportNumberSearch: "",
        reporter: [],
        toCities: [],
        toDate: moment().startOf("day").add(7, "days"),
      },
      locations: [],
      selectedCoordinates: {
        lat: 0,
        lng: 0,
      },
    }

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleOnGoToTruckTable = this.handleOnGoToTruckTable.bind(this);
    this.handleOnGoToUnitTable = this.handleOnGoToUnitTable.bind(this);
    this.handleFetchData = this.handleFetchData.bind(this);
    this.handleFilterPanelChange = this.handleFilterPanelChange.bind(this);
    this.getBounds = this.getBounds.bind(this);
    this.customPopup = this.customPopup.bind(this);
    this.drawRoute = this.drawRoute.bind(this);
    this.selectCompany = this.selectCompany.bind(this);
    this.closeCompanyPopup = this.closeCompanyPopup.bind(this);
    this.handleUnitSendEmailToReporter = this.handleUnitSendEmailToReporter.bind(this);
    this.handleTruckSendEmailToReporter = this.handleTruckSendEmailToReporter.bind(this);
    this.handleUnitSendEmail = this.handleUnitSendEmail.bind(this);
    this.handleTruckSendEmail = this.handleTruckSendEmail.bind(this);
    this.openCreateReportDialog = this.openCreateReportDialog.bind(this);
    this.closeCreateReportDialog = this.closeCreateReportDialog.bind(this);
    this.openAddNewUnitForm = this.openAddNewUnitForm.bind(this);
    this.openAddFreeTruckForm = this.openAddFreeTruckForm.bind(this);
  }

  public componentWillMount() {
    this.updateDimensions();
  }

  public componentDidMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this))

    this.reportersPromise = makeCancellable<LocationNameModel[] | never[]>(filtersApi.getReporters(true, true));
    this.reportersPromise
      .promise
      .then(data => {
        this.setState({ reporters: data });
      })
      .catch((reason) => console.log('Fetching failed:', reason));

      this.locationsPromise = makeCancellable<LocationModel[]>(locationApi.getLocations());
      this.locationsPromise
        .promise
        .then(data => this.setState({ locations: data }))
        .catch((reason) => console.log('Fetching failed:', reason));
  }

  public componentDidUpdate(prevProps: MapViewProps, prevState: MapViewState) {
    if (this.state.filters !== prevState.filters) {
      this.handleFetchData();
    }
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));

    if (this.reportersPromise != null) {
      this.reportersPromise.cancel();
    }
    if (this.locationsPromise != null) {
      this.locationsPromise.cancel();
    }
  }

  public render() {
    const {
      centerPosition,
      zoom,
      reporters,
      isCreateReportDialogOpen } = this.state;
    const { classes } = this.props;

    const initialSearchFilter = (this.props.trucks.selected && this.props.trucks.selected.reportNumber) ?
      this.props.trucks.selected.reportNumber :
      (this.props.units.selected && this.props.units.selected.reportNumber) ? this.props.units.selected.reportNumber : "";
    
    const isUnitDialogOpen = this.props.units.isSendingEmail || this.props.units.isSendingEmailToReporter;
    const isTruckDialogOpen = this.props.trucks.isSendingEmail || this.props.trucks.isSendingEmailToReporter;
    const isAddNewUnitFormOpen = this.props.units.isEditing;
    const isAddFreeTruckFormOpen = this.props.trucks.isEditing;

    return (
      <div>
        <Grid container direction="row" justify="space-between">
          <Grid item>
            <FilterPanel
              onFiltersChanged={this.handleFilterPanelChange}
              initialValues={{ reportNumberSearch: initialSearchFilter }}
              filterValues={{ reporters }}
              filterIncludes={{ trucks: true, units: true }}
              onSaveFilterCancel={this.props.filterSettingsActions.addOrEditFormCancelled}
              onSaveFilterSubmit={this.props.filterSettingsActions.addOrEditFormSubmitted}
              updateSaveFilterDestinationCities={this.props.filterSettingsActions.updateNewFilterSettingsDestinationCities}
              updateSaveFilterDepartureCities={this.props.filterSettingsActions.updateNewFilterSettingsDepartureCities}
              updateNewFilterSettingsReporters={this.props.filterSettingsActions.updateNewFilterSettingsReporters}
              filterSettings={this.props.filterSettings}
              onSaveFilter={this.props.filterSettingsActions.AddOrEditFilterSetting}
            />
          </Grid>
          <Grid item>
            <HelpButton anchor="mapview" />
          </Grid>
        </Grid>
        <MapFilter onFiltersChanged={this.handleFilterChange} />
        <Map
          className="leaflet_container"
          style={{ height: this.state.height }}
          center={centerPosition}
          zoom={zoom}
          maxBounds={mapMaxBounds}
          maxZoom={18}
          ref={this.getMapRef}
          closePopupOnClick={false}
          onclick={this.openCreateReportDialog}
        >

          <TileLayer
            attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MarkerClusterGroup iconCreateFunction={createClusterCustomIconGrey}>
            {this.state.routesChecked.departingTrucks ?
              <React.Fragment>
                {this.getDepartingTrucks()}
                {this.getArrivingTrucks()}
              </React.Fragment> : null}
            {this.state.routesChecked.departingArrivingUnits ?
              <React.Fragment>
                {this.getDepartingUnits()}
                {this.getArrivingUnits()}
              </React.Fragment>
              : null}
            {this.state.routesChecked.companies ? 
              <React.Fragment>
                {this.getCompanyLocations()}
              </React.Fragment>
              : null
            }
            {this.getFreeTruckRoutes()}
            {this.getFreeUnitRoutes()}
          </MarkerClusterGroup>
          {this.state.truckSelected === true ?
            <React.Fragment>
              {this.customPopup()}
            </React.Fragment> : null }
            {this.state.truckSelected === false ?
            <React.Fragment>
              {this.customUnitPopup()}
            </React.Fragment>:null}
            {this.state.companySelected &&
            <React.Fragment>
              {this.customCompanyPopup()}
            </React.Fragment>}
          <Control position="topright">
            
              <Grid>
                <Grid>
                  <table>
                    <tbody>
                      <tr>
                        <td><img src={RedMarker} /></td>
                        <td className="control-arriving">
                          <Typography color="secondary" variant="subtitle1"> {localizations.map.legendDest}</Typography>
                        </td>
                      </tr>
                      <tr>
                        <td><img src={BlueMarker} /></td>
                        <td className="control-departing">
                          <Typography color="primary" variant="subtitle1"> {localizations.map.legendDep}</Typography>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Grid>
                { this.state.routesChecked.departingTrucks ? 
                  <React.Fragment>
                    <Paper className={classes.paper}>
                      <table>
                        <tbody>
                          <tr>
                            <td><img src={TruckImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.trailer}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={PieceTruckImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.properties.pieceGoods}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={BulkTruckImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.properties.bulkGoods}</Typography>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Paper>
                  </React.Fragment>
                  : null
                }
                { this.state.routesChecked.departingArrivingUnits ? 
                  <React.Fragment>
                    <Paper className={classes.paper}>
                      <table>
                        <tbody>
                          <tr>
                            <td><img src={TrailerImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.trailer}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={SeaContainerImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.container}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={PiecegoodsImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.properties.pieceGoods}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={BulkgoodsImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.units.properties.bulkGoods}</Typography>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Paper>
                  </React.Fragment>
                  : null
                }
                { this.state.routesChecked.companies ? 
                  <React.Fragment>
                    <Paper className={classes.paper}>
                      <table>
                        <tbody>
                          <tr>
                            <td><img src={DeliveryCompanyImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.companyIndustryTypes[CompanyIndustryType.Transportation]}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={RetailImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.companyIndustryTypes[CompanyIndustryType.Retail]}</Typography>
                            </td>
                          </tr>
                          <tr>
                            <td><img src={CompanyImage} className="control-image"/></td>
                            <td className="control-departing">
                              <Typography color="primary" variant="subtitle1"> {localizations.companyIndustryTypes[CompanyIndustryType.Other]}</Typography>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Paper>
                  </React.Fragment>
                  : null
                }
              </Grid>
            
          </Control>
          {this.props.trucks.isLoading || this.props.units.isLoading ?
            <Control position="topleft">
              <CircularProgress color="primary" thickness={4} />
            </Control> : null}
        </Map>
        {isUnitDialogOpen ? (
            <UnitEmailDialog
                isOpen={isUnitDialogOpen}
                onSubmit={this.props.units.isSendingEmail ? this.props.unitActions.sendEmailSubmitted : this.props.unitActions.sendEmailToReporterSubmitted}
                onCancel={this.props.units.isSendingEmail ? this.props.unitActions.sendEmailCancelled : this.props.unitActions.sendEmailToReporterCancelled}
                toReporter={this.props.units.isSendingEmailToReporter}
            />
        ) : null}
        {isTruckDialogOpen ? (
            <TruckEmailDialog
                isOpen={isTruckDialogOpen}
                onSubmit={this.props.trucks.isSendingEmail ? this.props.truckActions.sendEmailSubmitted : this.props.truckActions.sendEmailToReporterSubmitted}
                onCancel={this.props.trucks.isSendingEmail ? this.props.truckActions.sendEmailCancelled : this.props.truckActions.sendEmailToReporterCancelled}
                toReporter={this.props.trucks.isSendingEmailToReporter}
            />
        ) : null}
        <AddNewUnitForm
          isOpen={isAddNewUnitFormOpen}
          editMode="add"
          onCancel={this.props.unitActions.addOrEditFormCancelled}
          onSubmit={this.props.unitActions.addOrEditFormSubmitted}
          resetTrailerIdentifier={this.props.unitActions.ResetAddNewUnitFormTrailerIdentifier}
        />
        <AddFreeTruckForm
          isOpen={isAddFreeTruckFormOpen}
          editMode="add"
          onSubmit={this.props.truckActions.addOrEditFormSubmitted}
          onCancel={this.props.truckActions.addOrEditFormCancelled}
        />
        <Dialog onClose={this.closeCreateReportDialog} aria-labelledby="new-report-dialog-title" open={isCreateReportDialogOpen}>
          <DialogTitle id="new-report-dialog-title">{localizations.actions.createReport}</DialogTitle>
          <List>
            <ListItem button onClick={this.openAddNewUnitForm}>
              <ListItemText primary={localizations.units.reportNewUnit} />
            </ListItem>
            <ListItem button onClick={this.openAddFreeTruckForm}>
              <ListItemText primary={localizations.trucks.reportNewTruck} />
            </ListItem>
          </List>
          </Dialog>
      </div>
    );
  }

  private customCompanyPopup() {
    
    const company = this.state.selectedCompany;

    const markerPosition: L.LatLngExpression = [this.state.selectedMarker.lat, this.state.selectedMarker.lng];

    if (!company) {
      return null;
    }
    return <div className="card" >
      <Popup onClose={this.closeCompanyPopup} key={company.id} position={markerPosition} minWidth={cardWidth}>
        <CompanyCard {...company} />
      </Popup>
    </div>
  }

  private getMapRef = (map: any) => this.mapComponent = map && map.leafletElement;

  private closePopup = () => {
    this.setState({ truckSelected: null, selectedTruck: null })
  }

  private closeUnitPopup = () => {
    this.setState({ truckSelected: null, selectedUnit: null })
  }

  private closeCompanyPopup = () => {
    this.setState({ companySelected: false })
  }
  
  private handleUnitSendEmailToReporter(unit: UnitModel) {
      this.props.unitActions.sendEmailToReporter(unit);
  }
  
  private handleTruckSendEmailToReporter(truck: TruckModel) {
      this.props.truckActions.sendEmailToReporter(truck);
  }
    
  private handleUnitSendEmail(unit: UnitModel) {
      this.props.unitActions.sendEmail(unit);
  }
    
  private handleTruckSendEmail(truck: TruckModel) {
      this.props.truckActions.sendEmail(truck);
  }

  private openCreateReportDialog(event: L.LeafletMouseEvent) {
    const { selectedUnit, selectedTruck, companySelected, locations } = this.state;
    
    if (selectedUnit || selectedTruck || companySelected || !locations.length) {
      return;
    }

    this.setState(
      {
        isCreateReportDialogOpen: true,
        selectedCoordinates: {
          lat: event.latlng.lat,
          lng: event.latlng.lng,
        },
      });
  }

  private closeCreateReportDialog() {
    this.setState({ isCreateReportDialogOpen: false });
  }

  private openAddNewUnitForm() {
    const location = this.getNearestLocation();
    const locationName: LocationNameModel = {
      id: location.id,
      name: location.name
    };
    this.props.setFormValue(`newUnit.${nameof<AddUnitModel>("departureCity")}`, locationName);
    this.setState({ isCreateReportDialogOpen: false });
    this.props.unitActions.addOrEditUnit(undefined, this.handleFetchData, false);
  }

  private openAddFreeTruckForm() {
    const location = this.getNearestLocation();
    const locationName: LocationNameModel = {
      id: location.id,
      name: location.name
    };
    this.props.setFormValue(`newTruck.${nameof<AddNewTruckModel>("departureCity")}`, locationName);
    this.setState({ isCreateReportDialogOpen: false });
    this.props.truckActions.addOrEditTruck(undefined, this.handleFetchData, false);
  }

  private getNearestLocation(): LocationModel {
    const { locations, selectedCoordinates } = this.state;
    const selectedPoint = new L.LatLng(selectedCoordinates.lat, selectedCoordinates.lng);
    let nearestLocation = locations[0];
    let distanceToNearestLocation = selectedPoint.distanceTo(new L.LatLng(nearestLocation.location.latitude, nearestLocation.location.longitude));

    for (let index = 1; index < locations.length; index++) {
      const location = locations[index];
      const point = new L.LatLng(location.location.latitude, location.location.longitude);
      const distanceToSelectedPoint = selectedPoint.distanceTo(point);

      if (distanceToSelectedPoint < distanceToNearestLocation) {
        nearestLocation = location;
        distanceToNearestLocation = distanceToSelectedPoint;
      }
    }

    return nearestLocation;
  }

  private getBounds(): L.LatLngBoundsExpression | undefined {
    if (this.props.trucks.selected && this.props.trucks.selected.destinationCity) {
      const pos1 = this.props.trucks.selected.departureCity.location;
      const pos2 = this.props.trucks.selected.destinationCity.location;

      const bounds: Array<[number, number]> = [[pos1.latitude, pos1.longitude], [pos2.latitude, pos2.longitude]];

      return bounds;
    }
    else if (this.props.units.selected) {
      const pos1 = this.props.units.selected.departureCity.location;
      const pos2 = this.props.units.selected.destinationCity.location;

      const bounds: Array<[number, number]> = [[pos1.latitude, pos1.longitude], [pos2.latitude, pos2.longitude]];

      return bounds;
    }

    return undefined;
  }

  private updateDimensions() {
    let height = window.innerWidth >= 592 ? window.innerHeight - 310 : 400
    if (height < 400) {
      height = 400;
    }

    this.setState({ height })
  }

  private handleFilterPanelChange(filters: FilterInfo) {
    // After filter change, reset truck and unit selection.
    this.props.truckActions.selectTruck(null);
    this.props.unitActions.selectUnit(null);
    this.setState({ filters });
  }

  private handleFetchData() {
    const { filters } = this.state;

    this.props.filterSettingsActions.RequestFilterSettingsData();
    this.props.truckActions.requestFreeTrucks(filters, true);
    this.props.unitActions.requestFreeUnits(filters, true);
    this.props.truckActions.requestTruckRoutes();

    this.props.companyActions.cacheFilters(filters);
    this.props.companyActions.requestVisibleCompanies(filters);
  }

  private handleFilterChange(filters: MapFilterInfo) {
    this.setState({
      routesChecked: {
        truckRoutes: filters.truckRoutes,
        departingArrivingUnits: filters.departingArrivingUnits,
        departingTrucks: filters.departingTrucks,
        companies: filters.companies
      }
    });
  }

  private getDepartingTrucksIcon(isPieceGoods?: boolean, isBulkGoods?: boolean) {
    if (isPieceGoods && !(isPieceGoods && isBulkGoods)) {
      return PieceTruckIconBlue;
    }
    if (isBulkGoods && !(isPieceGoods && isBulkGoods)) {
      return BulkTruckIconBlue;
    }

    return TruckIconBlue;
  }

  private getDepartingTrucks() {

    if (this.props.trucks.isLoading || !this.props.trucks.data) {
      return null;
    }
    return this.props.trucks.data
      .map((item, index) => {
        if (item.departureCity !== null) {
          const latitude = item.departureCity.location.latitude
          const longitude = item.departureCity.location.longitude
          return (
            <Marker
              key={item.id}
              position={[item.departureCity.location.latitude, item.departureCity.location.longitude]}
              icon={this.getDepartingTrucksIcon(item.properties.pieceGoods, item.properties.bulkGoods)}
              onClick={() => this.selectTruck(item, latitude, longitude, "departing")}
              onMouseOver={this.drawHoverRoute(item, RouteType.Trucks)}
              onMouseOut={this.clearHoverRoute}
            >
              <TruckTooltip {...item} />
            </Marker>
          );
        }
        else {
          return null;
        }
      });
  }

  private getArrivingTrucksIcon(isPieceGoods?: boolean, isBulkGoods?: boolean) {
    if (isPieceGoods && !(isPieceGoods && isBulkGoods)) {
      return PieceTruckIconRed;
    }
    if (isBulkGoods && !(isPieceGoods && isBulkGoods)) {
      return BulkTruckIconRed;
    }

    return TruckIconRed;
  }

  private getArrivingTrucks() {

    if (this.props.trucks.isLoading || !this.props.trucks.data) {
      return null;
    }

    return this.props.trucks.data
      .map((item, index) => {
        if (item.destinationCity !== undefined && item.departureCity !== undefined && item.destinationCity !== null && item.departureCity !== null) {
          const latitude = item.destinationCity.location.latitude
          const longitude = item.destinationCity.location.longitude
          return (
            <Marker
              key={item.id}
              position={[item.destinationCity.location.latitude, item.destinationCity.location.longitude]}
              icon={this.getArrivingTrucksIcon(item.properties.pieceGoods, item.properties.bulkGoods)}
              onClick={() => this.selectTruck(item, latitude, longitude, "arriving")}
              onMouseOver={this.drawHoverRoute(item, RouteType.Trucks)}
              onMouseOut={this.clearHoverRoute}
            >
              <TruckTooltip {...item} />
            </Marker>
          );
        }
        else {
          return null;
        }
      });
  }

  private selectTruck = (truck: any, latitude: number, longitude: number, route: string) => {
    this.setState({ selectedTruck: truck })

    if (this.hoverRouteLayer) {
      this.mapComponent.removeLayer(this.hoverRouteLayer);
      this.hoverRouteLayer = null;
    }

    this.setState({
      selectedMarker: { lat: latitude, lng: longitude },
      truckSelected: true,
      routeLocation: route,
      truckRoutes: true
    });
  }

  private selectUnit = (unit: any, latitude: number, longitude: number, route: string) => {
    this.setState({ selectedUnit: unit })

    if (this.hoverRouteLayer) {
      this.mapComponent.removeLayer(this.hoverRouteLayer);
      this.hoverRouteLayer = null;
    }
    
    this.setState({
      selectedMarker: { lat: latitude, lng: longitude },
      truckSelected: false,
      unitRouteLocation: route,
      truckRoutes: false
    });
  }

  private selectCompany =  (company: VisibleCompanyDataModel, latitude: number, longitude: number) => {
    this.setState({ selectedCompany: company })

    if (this.hoverRouteLayer) {
      this.mapComponent.removeLayer(this.hoverRouteLayer);
      this.hoverRouteLayer = null;
    }
    
    this.setState({
      selectedMarker: { lat: latitude, lng: longitude },
      companySelected: true,
    });
  }

  private customPopup() {
    const truck = this.state.selectedTruck

    const markerPosition: L.LatLngExpression = [this.state.selectedMarker.lat, this.state.selectedMarker.lng];

    if (!truck) {
      return null;
    }
    return <div className="card" >
      <Popup onClose={this.closePopup} key={truck.id} position={markerPosition} minWidth={cardWidth}>
        <TruckCard onGoToTable={this.handleOnGoToTruckTable} onSendEmailToReporter={this.handleTruckSendEmailToReporter} onSendEmail={this.handleTruckSendEmail} {...truck} />
      </Popup>
    </div>

  }

  private customUnitPopup() {
    const unit = this.state.selectedUnit
    const markerPosition: L.LatLngExpression = [this.state.selectedMarker.lat, this.state.selectedMarker.lng];
    if (!unit) {
      return null;
    }
    return <div className="card" >
      <Popup onClose={this.closeUnitPopup} key={unit.id} position={markerPosition} minWidth={cardWidth}>
        <UnitCard onGoToTable={this.handleOnGoToUnitTable} onSendEmailToReporter={this.handleUnitSendEmailToReporter} onSendEmail={this.handleUnitSendEmail} {...unit} />
      </Popup>
    </div>

  }

  private drawHoverRoute = ({ departureCity, destinationCity }: any, item: string) => () => {
    if (destinationCity && this.state.truckSelected === null) {
      const fromId = departureCity.id;
      const toId = destinationCity.id;
      this.drawRoute(fromId, toId, item)
    }   
  }

  private drawRoute = (fromId: string, toId: string, route: string) => {
    let currentRoute

    const routes = route === "truck" ? this.props.trucks.routes : this.props.units.routes

    currentRoute = routes.filter(item => item && item.from && item.to && item.from.id === fromId && item.to.id === toId)[0]

    if (this.mapComponent && currentRoute) {
      this.hoverRouteLayer = L.layerGroup();
      L.polyline(currentRoute.route, { color: 'black', weight: 3 }).addTo(this.hoverRouteLayer);
      this.mapComponent.addLayer(this.hoverRouteLayer);
    }
  }

  private clearHoverRoute = () => {
    if (this.hoverRouteLayer) {
      this.mapComponent.removeLayer(this.hoverRouteLayer);
      this.hoverRouteLayer = null;
    }
  }
  

  private getDepartingUnitsIcon(isContainer?: boolean, isPieceGoods?: boolean, isBulkGoods?: boolean) {
    if (isPieceGoods && !(isPieceGoods && isBulkGoods)) {
      return PiecegoodsIconBlue;
    }
    if (isBulkGoods && !(isPieceGoods && isBulkGoods)) {
      return BulkgoodsIconBlue;
    }
    if (isContainer) {
      return SeaContainerIconBlue;
    }

    return TrailerIconBlue;
  }


  private getDepartingUnits() {
    // If truck is selected in store, do not show units.
    const selected = this.props.trucks.selected;

    if (this.props.units.isLoading || !this.props.units.data) {
      return null;
    }

    return this.props.units.data
      .map(item => {
        const isContainer = item.trailerType === 'container20' || item.trailerType === 'containerOver20';
        
        return (
          <Marker
            key={item.id}
            position={[item.departureCity.location.latitude, item.departureCity.location.longitude]}
            icon={this.getDepartingUnitsIcon(isContainer, item.properties.pieceGoods, item.properties.bulkGoods)}
            onClick={() => this.selectUnit(item, item.departureCity.location.latitude, item.departureCity.location.longitude, "departing")}
            onMouseOver={this.drawHoverRoute(item, RouteType.Units)}
            onMouseOut={this.clearHoverRoute}
          >
            <UnitTooltip {...item} />
          </Marker>
        );
      });
  }
  

  private getArrivingUnitsIcon(isContainer?: boolean, isPieceGoods?: boolean, isBulkGoods?: boolean) {
    if (isPieceGoods && !(isPieceGoods && isBulkGoods)) {
      return PiecegoodsIconRed;
    }
    if (isBulkGoods && !(isPieceGoods && isBulkGoods)) {
      return BulkgoodsIconRed;
    }
    if (isContainer) {
      return SeaContainerIconRed;
    }

    return TrailerIconRed;
  }

  private getArrivingUnits() {
    // If truck is selected in store, do not show units.

    if (this.props.units.isLoading || !this.props.units.data) {
      return null;
    }

    return this.props.units.data
      .map(item => {
        const isContainer = item.trailerType === 'container20' || item.trailerType === 'containerOver20';
        
        return (
          <Marker
            key={item.id}
            position={[item.destinationCity.location.latitude, item.destinationCity.location.longitude]}
            icon={this.getArrivingUnitsIcon(isContainer, item.properties.pieceGoods, item.properties.bulkGoods)}
            onClick={() => this.selectUnit(item, item.destinationCity.location.latitude, item.destinationCity.location.longitude, "arriving")}
            onMouseOver={this.drawHoverRoute(item, RouteType.Units)}
            onMouseOut={this.clearHoverRoute}
          >
            <UnitTooltip {...item} />
          </Marker>
        );
      });
  }

  private getFreeTruckRoutes() {
    const truck = this.state.selectedTruck

    if (truck !== null && truck.id !== undefined && truck.destinationCity !== undefined && this.state.routesChecked.departingTrucks && this.state.truckRoutes !== false) {
      const selected = this.state.selectedTruck
      const fromId = selected ? selected.departureCity.id : undefined;
      const toId = selected && selected.destinationCity ? selected.destinationCity.id : undefined;

      return this.props.trucks.routes
        .map((route, index) => (
          route && route.from && route.to && (!selected || (selected && route.from.id === fromId && route.to.id === toId)) ?
            <Polyline
              key={index}
              color={route.target.id === this.selectedTarget
                ? myCustomSelectionColor : this.state.routeLocation === "arriving"
                  ? myCustomRedColour : myCustomBlueColour}
              weight={3}
              positions={route.route}
            /> : null
        ));
    }
    else {
      return null
    }
  }

  private getFreeUnitRoutes() {
    const unit = this.state.selectedUnit
    
    if (unit !== null && unit.id !== undefined && unit.destinationCity !== undefined && this.state.routesChecked.departingArrivingUnits && this.state.truckRoutes === false ) {
      const selected = this.state.selectedUnit
      const fromId = selected ? selected.departureCity.id : undefined;
      const toId = selected && selected.destinationCity ? selected.destinationCity.id : undefined;
      return this.props.units.routes
        .map((route, index) => (
          route && route.from && route.to && (!selected || (selected && route.from.id === fromId && route.to.id === toId)) ?
            <Polyline
              key={index}
              color={route.target.id === this.selectedTarget
                ? myCustomSelectionColor : this.state.unitRouteLocation === "arriving"
                  ? myCustomRedColour : myCustomBlueColour}
              weight={3}
              positions={route.route}
            /> : null
        ));
    }
    else {
      return null
    }
  }

  private getCompanyIcon(industryType?: string) {
    switch (industryType) {
      case CompanyIndustryType.Transportation:
        return DeliveryCompanyIcon;
      case CompanyIndustryType.Retail:
        return RetailIcon;
      case CompanyIndustryType.Other:
        return CompanyIcon;
      default: 
        return CompanyIcon;
    }
  }

  private getCompanyLocations() {
    if (this.props.companies.isLoading || !this.props.companies.data) {
      return null;
    }

    return this.props.companies.data
      .map(item => {
        const latitude = item.address && item.address.geoPoint ? item.address.geoPoint.latitude : 60.996895;
        const longitude = item.address && item.address.geoPoint ? item.address.geoPoint.longitude : 24.466265;
        return (
      <Marker
        key={item.id}
        position={[latitude, longitude]}
        icon={this.getCompanyIcon(item.industryType)}
        onClick={() => this.selectCompany(item, latitude, longitude)}
      >
        <CompanyTooltip {...item} />
        </Marker>

    )});
  }


  private handleOnGoToTruckTable(truck: TruckModel) {
    this.props.truckActions.selectTruck(truck);
    this.props.goToActions.goTo("/freetrucks");
  }
  private handleOnGoToUnitTable(unit: UnitModel) {
    this.props.unitActions.selectUnit(unit);
    this.props.goToActions.goTo("/freeunits");
  }
}

const mapStateToProps = (state: ApplicationState) => {
  const { units, trucks, filterSettings } = state;
  const companies = state.visibleCompanies;
  return { units, trucks, companies, filterSettings };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    filterSettingsActions: bindActionCreators(FsStore.actionsCreators, dispatch),
    unitActions: bindActionCreators(UnitStore.actionCreators, dispatch),
    truckActions: bindActionCreators(TruckStore.actionCreators, dispatch),
    companyActions: bindActionCreators(CompaniesStore.actionCreators, dispatch),
    goToActions: bindActionCreators(goActions, dispatch),
    setFormValue: (model: string, value: any) => dispatch(actions.change(model, value)),
  }
}

const goActions = {
  goTo: (location: string) => push(location)
}

export default withStyles(styles)(connect<any, any, any>(mapStateToProps, mapDispatchToProps)(MapView));



// WEBPACK FOOTER //
// ./src/map/MapView.tsx